import { action } from 'easy-peasy';
import { IActionDeleteActivityLog } from '../types';

const deleteActivityLog: IActionDeleteActivityLog = action((state, id) => {
  state.itemsByPatientId = state.itemsByPatientId.filter(item => item.id !== id);
});

export default deleteActivityLog;
